import { chat } from "../../state/chat";
import { useTypedDispatch, useTypedSelector } from "../../state/store";
import {
  CHAT_DEFAULT_WIDTH,
  CHAT_MAX_WIDTH,
  CHAT_MIN_WIDTH,
  clampChatWidth,
} from "../../utilities/chat";

const KEYBOARD_STEP = 24;

type ChatResizeHandleProps = {
  onResizingChange: (isResizing: boolean) => void;
};

export const ChatResizeHandle = ({
  onResizingChange,
}: ChatResizeHandleProps) => {
  const dispatch = useTypedDispatch();
  const width = useTypedSelector((s) => s.chat.width);

  const setWidth = (next: number) => {
    dispatch(chat.actions.setWidth(clampChatWidth(next, window.innerWidth)));
  };

  const handlePointerDown = (e: React.PointerEvent) => {
    if (e.button !== 0) return;
    e.preventDefault();

    const grabOffset = e.clientX - width;
    const previousUserSelect = document.body.style.userSelect;
    document.body.style.userSelect = "none";
    onResizingChange(true);

    const handleMove = (move: PointerEvent) => {
      setWidth(move.clientX - grabOffset);
    };
    const handleUp = () => {
      document.body.style.userSelect = previousUserSelect;
      onResizingChange(false);
      window.removeEventListener("pointermove", handleMove);
      window.removeEventListener("pointerup", handleUp);
    };

    window.addEventListener("pointermove", handleMove);
    window.addEventListener("pointerup", handleUp);
  };

  const handleKeyDown = (e: React.KeyboardEvent) => {
    if (e.key === "ArrowLeft") {
      e.preventDefault();
      setWidth(width - KEYBOARD_STEP);
    } else if (e.key === "ArrowRight") {
      e.preventDefault();
      setWidth(width + KEYBOARD_STEP);
    }
  };

  return (
    <div
      role="separator"
      aria-orientation="vertical"
      aria-label="Resize Ask Playbook"
      aria-valuenow={width}
      aria-valuemin={CHAT_MIN_WIDTH}
      aria-valuemax={CHAT_MAX_WIDTH}
      tabIndex={0}
      onPointerDown={handlePointerDown}
      onKeyDown={handleKeyDown}
      onDoubleClick={() => {
        setWidth(CHAT_DEFAULT_WIDTH);
      }}
      className="group absolute inset-y-0 -right-1 z-20 hidden w-2 cursor-col-resize touch-none outline-none md:block"
    >
      <span className="pointer-events-none absolute inset-y-0 left-1/2 w-0.5 -translate-x-1/2 bg-transparent transition-colors group-hover:bg-brand-solid group-focus-visible:bg-brand-solid" />
    </div>
  );
};
